import { useState } from 'react';
import { usePermissions } from '../../../hooks/usePermissions';
import { PrivateNotesDatabase } from '../../../types';
import { useGetPrivateNotes } from '../api/useGetPrivateNotes';
import { flattenUniquePages, getId } from '../../../utils/pagination';

export function usePrivateNotes() {
  const { isAdmin } = usePermissions();
  const {
    data: notePages,
    isLoading,
    error,
    hasNextPage,
    isFetchingNextPage,
    isFetchNextPageError,
    fetchNextPage,
  } = useGetPrivateNotes();

  const [isCreationModalOpened, setIsCreationModalOpened] = useState<boolean>(false);
  const [noteToUpdate, setNoteToUpdate] = useState<PrivateNotesDatabase | null>(null);
  const [noteToDelete, setNoteToDelete] = useState<PrivateNotesDatabase | null>(null);

  return {
    isAdmin,
    notes: flattenUniquePages(notePages?.pages, getId),
    hasMore: hasNextPage,
    isLoadingMore: isFetchingNextPage,
    isLoadMoreError: isFetchNextPageError,
    handleLoadMore: () => fetchNextPage(),
    isLoading,
    hasError: Boolean(error),
    isCreationModalOpened,
    noteToUpdate,
    noteToDelete,
    handleOpenCreationModal: () => setIsCreationModalOpened(true),
    handleCloseCreationModal: () => setIsCreationModalOpened(false),
    handleOpenUpdateModal: (note: PrivateNotesDatabase) => setNoteToUpdate(note),
    handleCloseUpdateModal: () => setNoteToUpdate(null),
    handleOpenDeleteModal: (note: PrivateNotesDatabase) => setNoteToDelete(note),
    handleCloseDeleteModal: () => setNoteToDelete(null),
  };
}
